import { type ComponentPropsWithoutRef, forwardRef, memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type SearchCommandActionsProps = ComponentPropsWithoutRef<'div'>;

export const SearchCommandActions = memo(
  forwardRef<HTMLDivElement, SearchCommandActionsProps>(({ className, ...restOfProps }, ref) => {
    return (
      <div
        className={cn('absolute top-0 right-2 bottom-0 flex items-center gap-2', className)}
        ref={ref}
        {...restOfProps}
      />
    );
  }),
);

SearchCommandActions.displayName = 'SearchCommandActions';
